export default __webpack_public_path__ + "static/0230-981b4c9183e5ce9e8d613e0a4132f824.png";